'use client';

import { FacebookIcon } from 'assets/icons/facebook-icon';

const linkClassName =
  'header-social-icon flex items-center text-secondary hover:opacity-70 transition-opacity';

export function FacebookLink() {
  return (
    <a
      aria-label="Facebook"
      className={linkClassName}
      href="https://www.facebook.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      <FacebookIcon height={32} width={32} />
    </a>
  );
}
